import React from 'react';
import { Helmet } from 'react-helmet';

const WebsiteSchema = () => {
  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Inkox",
    "url": "https://inkox.com/",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://inkox.com/search?query={search_term_string}",
      "query-input": "required name=search_term_string"
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </Helmet>
  );
};

export default WebsiteSchema;
